import React from "react";
import { Button, ButtonSize, useModalState } from "@jasperlabs/jux-next";
import { RequestAllocationMobile } from "./RequestAllocationCard";

export function InvestMobile({
	offer,
	...props
}: React.ComponentProps<typeof RequestAllocationMobile>) {
	const modalState = useModalState();

	if (offer.status === "OPEN" || offer.status === "OVERSUBSCRIBED") {
		return (
			<>
				<Button
					size={ButtonSize.Small}
					data-testid="offer-invest-button"
					className="xs:w-full md:w-1/2"
					onClick={() => {
						modalState.openModal();
					}}
				>
					Invest
				</Button>
				<RequestAllocationMobile
					offer={offer}
					modalState={modalState}
					{...props}
				/>
			</>
		);
	}

	if (offer.status === "CLOSED" || offer.status === "PRE_OPEN") {
		return null;
	}

	return offer.status satisfies never;
}
